// extracted by mini-css-extract-plugin
export default {"wrapper":"src-components-TestStart-TestStart-module__wrapper--LqRt3"};